export default __webpack_public_path__ + "static/media/Dashboard.e6ac1038.svg";